import * as React from 'react';
import { useLazyQuery } from '@apollo/client';
import Season from '../../models/season';
import { Button, Loader, Modal } from '@teamsnap/teamsnap-ui';
import * as DeleteSeasonValidationQuery from '../../core/gql/queries/detele_season_validation';

export interface Props {
  season: Season;
  performAction: Function;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  showDeleteModal: boolean;
  loading: boolean;
  isDeletable: boolean;
}

const SeasonDeleteModal: React.FunctionComponent<Props> = ({
  season,
  performAction,
  setShowDeleteModal,
  showDeleteModal,
  loading,
  isDeletable,
}) => (
  <Modal
    heading={`Delete ${season.name} Season`}
    style={{ minWidth: '351px', width: '351px', textAlign: 'start' }}
    show={showDeleteModal}
    showClose
    closeFn={() => setShowDeleteModal(false)}
  >
    <div className="modal-container">
      <div>
        {loading && <Loader type="spin" text="Validating..." />}
        {!loading && isDeletable && (
          <>
            <p data-testid="deleteModalMessage">
              Are you sure you wish to permanently delete this season? This will permanently delete all related
              registration forms, divisions, and teams from the season.
            </p>
            <div className="buttons-wrapper">
              <Button mods="u-spaceRightSm" onClick={() => setShowDeleteModal(false)} testId="modalCancelButton">
                Cancel
              </Button>
              <Button mods="Button Button--primary" onClick={() => performAction('delete')} testId="modalDeleteButton">
                Delete
              </Button>
            </div>
          </>
        )}

        {!loading && !isDeletable && (
          <>
            <p data-testid="deleteModalArchiveMessage">
              Seasons with registration forms or payment information can only be archived and not deleted. Season without payment information,
              but with one or more participants requires the participants to be deleted before the season can be
              deleted. Please review this season's activity before attempting to delete.
            </p>
            <div className="buttons-wrapper">
              <Button mods="u-spaceRightSm" onClick={() => setShowDeleteModal(false)} testId="modalCancelButton">
                Cancel
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  </Modal>
);

export default SeasonDeleteModal;
